import { ServiceBase } from '../../../../../../core/services/ServiceBase'
import BankProxy from './BankProxy'

class BankService extends ServiceBase {
  postCapitalAdequacy(params) {
    return this.getData(() => BankProxy.postCapitalAdequacy(params))
  }
  downloadCapitalAdequacy(params) {
    return this.getFileDownload(() => BankProxy.downloadCapitalAdequacy(params))
  }
  postAssetQuality(params) {
    return this.getData(() => BankProxy.postAssetQuality(params))
  }
  downloadAssetQuality(params) {
    return this.getFileDownload(() => BankProxy.downloadAssetQuality(params))
  }
  postEarningQuality(params) {
    return this.getData(() => BankProxy.postEarningQuality(params))
  }
  downloadEarningQuality(params) {
    return this.getFileDownload(() => BankProxy.downloadEarningQuality(params))
  }
  postLiquidity(params) {
    return this.getData(() => BankProxy.postLiquidity(params))
  }
  downloadLiquidity(params) {
    return this.getFileDownload(() => BankProxy.downloadLiquidity(params))
  }
  postBusinessGrowth(params) {
    return this.getData(() => BankProxy.postBusinessGrowth(params))
  }
  downloadBusinessGrowth(params) {
    return this.getFileDownload(() => BankProxy.downloadBusinessGrowth(params))
  }
}

export default new BankService()
